export default {
    1: "Agriculture, forestry and fishing",
    2: "Mining",
    3: "Manufacturing",
    4: "Electricity, Gas, Steam and Air Conditioning Suppliers",
    5: "Water, sewage and waste treatment, raw material recycling",
    6: "Construction Industry",
    7: "Wholesale and retail",
    8: "Transport and warehousing",
    9: "Accommodation and restaurant business",
    10: "Information and Communication Industry",
    11: "Financial and Insurance",
    12: "Real estate",
    13: "Professional, Scientific and Technical Services",
    14: "Business facility management, business support and rental services",
    15: "Public Administration, Defense and Social Security Administration",
    16: "Educational Services",
    17: "Health and Social Welfare Services",
    18: "Art, sports and leisure-related services",
    19: "Associations and organizations, repair and other personal services",
    20: "Employment activities within households and production activities for self-consumption, not elsewhere classified",
    21: "International and Foreign Organizations",
};